import {
  GETCLAIMCATEGORYNATUREOFCLAIM,
  GETCLAIMITEM,
} from "../constant/apiPath";
import { ccwpApi } from "@/services";

export const ClaimDetailApi = ccwpApi.injectEndpoints({
  endpoints: (builder) => ({
    getClaimCategoryNatureOfClaim: builder.query<any, any>({
      query: (caseId) => `${GETCLAIMCATEGORYNATUREOFCLAIM}${caseId}`,
    }),
    getClaimItemDetails: builder.query<any, any>({
      query: (arg) => `${GETCLAIMITEM}${arg.claimItemId}&caseId=${arg.caseId}`,
    }),
    bulkUpdateClaimStagesAndStatuses: builder.mutation<any, any>({
      query: (body) => ({
        url: 'Claim/BulkUpdateClaimStagesAndStatuses',
        method: 'POST',
        body,
      }),
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useGetClaimCategoryNatureOfClaimQuery,
  useLazyGetClaimCategoryNatureOfClaimQuery,
  useGetClaimItemDetailsQuery,
  useBulkUpdateClaimStagesAndStatusesMutation,
} = ClaimDetailApi;
